// кирпичный
// монолитный
// деревянный

import materialType from './material-type';

export default materialType.filter(mt => [
    'brick',
    'monolith',
    'wood',
].includes(mt.key));
